import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Select } from '../../components/select/select';
import { Button } from '../../components/button/button';
import theme from '../../theme';
import { Box, Grid, GridItem, Text } from '@chakra-ui/react';
import { AdminListPageLayout } from '../../components/admin-list-page-layout/admin-list-page-layout';
import { options, filterOptions, ALL_USERS, HIDE_EXTERNAL_USERS } from './user-list-constants';
import { styles } from './user-list-styles';
import { ButtonSize } from '../../core/enums';
import { DataGrid } from '../../components/data-grid/data-grid';
import { gridOptions, userListColumnDefs, getUserListEndpointData } from './user-list-utils';
import { SearchBar } from '../../components/search-bar/search-bar';
import { RowsPerPage } from '../../components/rows-per-page/rows-per-page';
export const UserList = (props)=>{
    const { auth, rootContext, addUser, editPermission } = props;
    const classes = styles();
    const [selectedValue, setSelectedValue] = useState(options[1].value);
    const [selectedFilter, setSelectedFilter] = useState(filterOptions[1].value);
    const [searchText, setSearchText] = useState('');
    const [pageSize, setPageSize] = useState(25);
    const [filterableOptions, setFilterableOptions] = useState();
    const tenant = props?.activeUser?.roles?.[0];
    const tenantRoles = tenant?.roles || [];
    const roleNames = tenantRoles.map((role)=>role.roleName);
    const endPoint = getUserListEndpointData(roleNames);
    const onOptionChange = (e)=>{
        setSelectedValue(e?.target?.textContent);
    };
    const onSearchInputChange = (e)=>{
        setSearchText(e?.target?.value);
    };
    const onFilterOptionChange = (e)=>{
        setSelectedFilter(e?.target?.textContent);
    };
    const onAddUserClick = (event)=>{
        event.preventDefault();
        addUser(auth, rootContext);
    };
    const generateNewFilterList = ()=>{
        const newFilterableOptions = {};
        const newFilterList = [];
        if (selectedFilter === filterOptions[0].value) {
            newFilterList.push(ALL_USERS);
        } else {
            newFilterList.push(HIDE_EXTERNAL_USERS);
        }
        if (searchText.trim().length) {
            if (selectedValue === options[0].value) {
                newFilterList.push({
                    key: 'username',
                    terms: [
                        searchText.trim()
                    ],
                    type: 'LIKE'
                });
            } else {
                newFilterList.push({
                    key: 'lastName',
                    terms: [
                        searchText.trim()
                    ],
                    type: 'LIKE'
                });
            }
        }
        newFilterableOptions.filters = newFilterList;
        return newFilterableOptions;
    };
    const onSearchKeyPress = (event)=>{
        if (event.keyCode === 13) {
            const SortablePageable = generateNewFilterList();
            setFilterableOptions(SortablePageable);
        }
    };
    const handleRowSelection = (rowdata)=>{
        props.getDetail(auth, rowdata, rootContext);
    };
    useEffect(()=>{
        const SortablePageable = generateNewFilterList();
        setFilterableOptions(SortablePageable);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedFilter
    ]);
    const onPageSizeChange = (pageSize)=>{
        setPageSize(pageSize);
    };
    return /*#__PURE__*/ _jsxs(AdminListPageLayout, {
        children: [
            /*#__PURE__*/ _jsx(Box, {
                flexShrink: 0,
                children: /*#__PURE__*/ _jsxs(Grid, {
                    flexDirection: 'row',
                    gridTemplateColumns: `1fr ${theme.space[100]}`,
                    children: [
                        /*#__PURE__*/ _jsx(GridItem, {
                            children: /*#__PURE__*/ _jsx(SearchBar, {
                                selectOptions: options,
                                selectedOption: selectedValue,
                                onSelectOptionChange: onOptionChange,
                                onSearchInputChange: onSearchInputChange,
                                onSearchKeyPress: onSearchKeyPress
                            })
                        }),
                        /*#__PURE__*/ _jsx(GridItem, {
                            sx: classes.addUserButtonGrid,
                            children: /*#__PURE__*/ _jsx(Button, {
                                size: ButtonSize.MD,
                                label: 'Add User',
                                backgroundColor: theme.colors.accent[100],
                                color: theme.colors.text['light'],
                                onClick: onAddUserClick,
                                dataTestId: 'createUserButton'
                            })
                        })
                    ]
                })
            }),
            editPermission && /*#__PURE__*/ _jsx(Box, {
                flexShrink: 0,
                paddingTop: theme.space[16],
                children: /*#__PURE__*/ _jsxs(Grid, {
                    display: 'flex',
                    flexDirection: "row",
                    justifyContent: 'space-between',
                    children: [
                        /*#__PURE__*/ _jsxs(Grid, {
                            templateColumns: `${theme.space[80]} 0.5fr 1fr 1fr`,
                            sx: classes.filterGrid,
                            children: [
                                /*#__PURE__*/ _jsx(GridItem, {
                                    sx: classes.textGridItem,
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        children: "User Filters: "
                                    })
                                }),
                                /*#__PURE__*/ _jsx(GridItem, {
                                    children: /*#__PURE__*/ _jsx(Select, {
                                        value: selectedFilter,
                                        items: filterOptions,
                                        onChange: onFilterOptionChange,
                                        dataTestId: 'userFilterSelect'
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Grid, {
                            children: /*#__PURE__*/ _jsx(RowsPerPage, {
                                pageSize: pageSize,
                                handlePageSize: onPageSizeChange
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Box, {
                paddingTop: theme.space[16],
                flex: "1 1 0",
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                children: /*#__PURE__*/ _jsx(DataGrid, {
                    columnDefs: userListColumnDefs,
                    gridOptions: gridOptions,
                    serverSideInfiniteScroll: true,
                    filterableOptions: filterableOptions,
                    endpointData: endPoint,
                    onRowClicked: (item)=>handleRowSelection(item?.data),
                    paginationPageSize: pageSize
                })
            })
        ]
    });
};
